import { render, staticRenderFns } from "./PersonContactInfoView.vue?vue&type=template&id=7524c614&scoped=true"
import script from "./PersonContactInfoView.vue?vue&type=script&lang=js"
export * from "./PersonContactInfoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7524c614",
  null
  
)

export default component.exports